import { c as _c } from "react/compiler-runtime";
import { CalculatePriceInterface, DigitalCheckout as Checkout, StoreImageEnum } from '@systemeio/digital-store-shared';
import { cents, CurrencyEnum, FormInput, PaymentMethodEnum } from '@systemeio/ui';
import { toPercent } from '@systemeio/util';
import { DigitalProductChangeInterface } from 'modules/digital-product/types/digital-product-interface';
import StoreFields from 'modules/stores/store/components/contact-fields';
import ItemSteps from 'modules/stores/store/components/item-steps';
import StoreImageSelector from 'modules/stores/store/components/store-image-selector';
import { StoreTextEditor } from 'modules/stores/store/components/store-text-editor';
import PaymentMethodsEditModal from 'modules/stores/store/content/product/components/payment-methods-edit-modal';
import { PricePlanItem } from 'modules/stores/store/content/product/digital-product/components/price-plan-item';
import { digitalProductInitFields } from 'modules/stores/store/content/product/digital-product/constants/mandatory-fields';
import { ProductDownloadItemEditType, ProductDownloadItemErrorsType, ProductECourseItemEditType, ProductECourseItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
interface Props<StateType extends ProductDownloadItemEditType | ProductECourseItemEditType, ErrorsType extends ProductDownloadItemErrorsType | ProductECourseItemErrorsType> {
  tempState: StateType;
  setTempState: Dispatch<SetStateAction<StateType>>;
  tempProduct: DigitalProductChangeInterface;
  setTempProduct: Dispatch<SetStateAction<DigitalProductChangeInterface>>;
  errors: ErrorsType;
  pricePlanErrors: string[];
  currency?: CurrencyEnum;
  paymentMethods?: PaymentMethodEnum[];
  imageType: StoreImageEnum;
}
const CheckoutTab = t0 => {
  const $ = _c(120);
  const {
    tempState,
    setTempState,
    errors,
    setTempProduct,
    tempProduct,
    currency,
    paymentMethods,
    pricePlanErrors,
    imageType
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  let t1;
  bb0: {
    const firstPricePlan = tempProduct.pricePlans?.[0];
    if (!firstPricePlan) {
      t1 = undefined;
      break bb0;
    }
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        amount: cents(0),
        rate: toPercent(0)
      };
      t3 = {
        amount: cents(0),
        percent: toPercent(0)
      };
      t4 = {
        amount: cents(0),
        tax: {
          amount: cents(0),
          rate: toPercent(0)
        }
      };
      $[0] = t2;
      $[1] = t3;
      $[2] = t4;
    } else {
      t2 = $[0];
      t3 = $[1];
      t4 = $[2];
    }
    let t5;
    if ($[3] !== firstPricePlan.amount || $[4] !== firstPricePlan.currency || $[5] !== firstPricePlan.id) {
      t5 = {
        originalAmount: firstPricePlan.amount,
        grossAmount: firstPricePlan.amount,
        pricePlan: firstPricePlan.id,
        quantity: 1,
        netAmount: firstPricePlan.amount,
        discountedNetAmount: firstPricePlan.amount,
        tax: t2,
        discount: t3,
        shippingFee: t4,
        currencyCode: firstPricePlan.currency
      };
      $[3] = firstPricePlan.amount;
      $[4] = firstPricePlan.currency;
      $[5] = firstPricePlan.id;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t1 = t5;
  }
  const calculatePrice = t1;
  let t2;
  if ($[7] !== calculatePrice || $[8] !== currency || $[9] !== paymentMethods || $[10] !== setPreview || $[11] !== setSingleItemMode || $[12] !== tempProduct.pricePlans || $[13] !== tempState.checkoutPage || $[14] !== tempState.productType || $[15] !== tempState.thankYouPage) {
    t2 = () => {
      setPreview([<Checkout key="Checkout page preview" calculatePrice={calculatePrice} checkoutPage={tempState.checkoutPage} paymentMethods={paymentMethods} currency={currency} pricePlans={tempProduct.pricePlans} thankYouPage={tempState.thankYouPage} productType={tempState.productType} displayAffiliateLink={false} skipDisabledButton={true} />]);
      setSingleItemMode(false);
    };
    $[7] = calculatePrice;
    $[8] = currency;
    $[9] = paymentMethods;
    $[10] = setPreview;
    $[11] = setSingleItemMode;
    $[12] = tempProduct.pricePlans;
    $[13] = tempState.checkoutPage;
    $[14] = tempState.productType;
    $[15] = tempState.thankYouPage;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== calculatePrice || $[18] !== currency || $[19] !== paymentMethods || $[20] !== setPreview || $[21] !== setSingleItemMode || $[22] !== tempProduct.pricePlans || $[23] !== tempState) {
    t3 = [calculatePrice, currency, paymentMethods, setPreview, setSingleItemMode, tempProduct.pricePlans, tempState];
    $[17] = calculatePrice;
    $[18] = currency;
    $[19] = paymentMethods;
    $[20] = setPreview;
    $[21] = setSingleItemMode;
    $[22] = tempProduct.pricePlans;
    $[23] = tempState;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  useEffect(t2, t3);
  let t4;
  if ($[25] !== t) {
    t4 = t("dashboard.store.image.select_image");
    $[25] = t;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  const t5 = tempState.checkoutPage.cover;
  let t6;
  if ($[27] !== t) {
    t6 = t("dashboard.store.product.checkout_image_label");
    $[27] = t;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== setTempState) {
    t7 = dataFile => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        cover: dataFile
      }
    }));
    $[29] = setTempState;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== imageType || $[32] !== t6 || $[33] !== t7 || $[34] !== tempState.checkoutPage.cover) {
    t8 = <StoreImageSelector dataFile={t5} imageType={imageType} label={t6} onChange={t7} />;
    $[31] = imageType;
    $[32] = t6;
    $[33] = t7;
    $[34] = tempState.checkoutPage.cover;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== t4 || $[37] !== t8) {
    t9 = {
      key: "image",
      title: t4,
      element: t8
    };
    $[36] = t4;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] !== t) {
    t10 = t("dashboard.store.item.add_text");
    $[39] = t;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  const t11 = tempState.checkoutPage.title;
  let t12;
  if ($[41] !== t) {
    t12 = t("dashboard.store.item.title");
    $[41] = t;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== setTempState) {
    t13 = t14 => {
      const {
        target: t15
      } = t14;
      const {
        value
      } = t15;
      return setTempState(prev_0 => ({
        ...prev_0,
        checkoutPage: {
          ...prev_0.checkoutPage,
          title: value
        }
      }));
    };
    $[43] = setTempState;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  const t14 = errors["checkoutPage.title"];
  let t15;
  if ($[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== tempState.checkoutPage.title) {
    t15 = <FormInput required={true} value={t11} label={t12} onChange={t13} error={t14} />;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = tempState.checkoutPage.title;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  const t16 = tempState.checkoutPage.buttonTitle;
  let t17;
  if ($[50] !== t) {
    t17 = t("dashboard.store.item.button");
    $[50] = t;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== setTempState) {
    t18 = t19 => {
      const {
        target: t20
      } = t19;
      const {
        value: value_0
      } = t20;
      return setTempState(prev_1 => ({
        ...prev_1,
        checkoutPage: {
          ...prev_1.checkoutPage,
          buttonTitle: value_0
        }
      }));
    };
    $[52] = setTempState;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  const t19 = errors["checkoutPage.buttonTitle"];
  let t20;
  if ($[54] !== t17 || $[55] !== t18 || $[56] !== t19 || $[57] !== tempState.checkoutPage.buttonTitle) {
    t20 = <FormInput required={true} value={t16} label={t17} onChange={t18} error={t19} />;
    $[54] = t17;
    $[55] = t18;
    $[56] = t19;
    $[57] = tempState.checkoutPage.buttonTitle;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== t15 || $[60] !== t20) {
    t21 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t15}{t20}</div>;
    $[59] = t15;
    $[60] = t20;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t) {
    t22 = t("dashboard.store.item.description");
    $[62] = t;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  const t23 = tempState.checkoutPage.description;
  let t24;
  if ($[64] !== setTempState) {
    t24 = value_1 => setTempState(prev_2 => ({
      ...prev_2,
      checkoutPage: {
        ...prev_2.checkoutPage,
        description: value_1
      }
    }));
    $[64] = setTempState;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  const t25 = errors["checkoutPage.description"] && "border-danger";
  let t26;
  if ($[66] !== t25) {
    t26 = twJoin(t25);
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  const t27 = errors["checkoutPage.description"];
  let t28;
  if ($[68] !== t22 || $[69] !== t24 || $[70] !== t26 || $[71] !== t27 || $[72] !== tempState.checkoutPage.description) {
    t28 = <StoreTextEditor label={t22} required={true} content={t23} onChange={t24} className={t26} error={t27} />;
    $[68] = t22;
    $[69] = t24;
    $[70] = t26;
    $[71] = t27;
    $[72] = tempState.checkoutPage.description;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== t21 || $[75] !== t28) {
    t29 = <div className="flex flex-col gap-5">{t21}{t28}</div>;
    $[74] = t21;
    $[75] = t28;
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  let t30;
  if ($[77] !== t10 || $[78] !== t29) {
    t30 = {
      key: "text",
      title: t10,
      element: t29
    };
    $[77] = t10;
    $[78] = t29;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== t) {
    t31 = t("dashboard.store.item.collect_info");
    $[80] = t;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== setTempState) {
    t32 = fields => setTempState(prev_3 => ({
      ...prev_3,
      checkoutPage: {
        ...prev_3.checkoutPage,
        fields
      }
    }));
    $[82] = setTempState;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  const t33 = errors["checkoutPage.fields"];
  let t34;
  if ($[84] !== t32 || $[85] !== t33 || $[86] !== tempState.checkoutPage.fields) {
    t34 = <StoreFields fields={tempState.checkoutPage.fields} onChange={t32} initFields={digitalProductInitFields} error={t33} />;
    $[84] = t32;
    $[85] = t33;
    $[86] = tempState.checkoutPage.fields;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== t31 || $[89] !== t34) {
    t35 = {
      key: "fields",
      title: t31,
      element: t34
    };
    $[88] = t31;
    $[89] = t34;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  let t36;
  if ($[91] !== t) {
    t36 = t("dashboard.funnel.configuration.offer.price_plans");
    $[91] = t;
    $[92] = t36;
  } else {
    t36 = $[92];
  }
  const t37 = errors["digitalProduct.pricePlans"];
  let t38;
  if ($[93] !== pricePlanErrors || $[94] !== t37) {
    t38 = [...pricePlanErrors, t37].filter(Boolean);
    $[93] = pricePlanErrors;
    $[94] = t37;
    $[95] = t38;
  } else {
    t38 = $[95];
  }
  let t39;
  if ($[96] !== setTempProduct) {
    t39 = pricePlans => {
      setTempProduct(prev_4 => ({
        ...prev_4,
        pricePlans
      }));
    };
    $[96] = setTempProduct;
    $[97] = t39;
  } else {
    t39 = $[97];
  }
  let t40;
  if ($[98] !== currency || $[99] !== t38 || $[100] !== t39 || $[101] !== tempProduct.id || $[102] !== tempProduct.pricePlans) {
    t40 = <PricePlanItem errors={t38} currency={currency} pricePlans={tempProduct.pricePlans} onChange={t39} digitalProductId={tempProduct.id} />;
    $[98] = currency;
    $[99] = t38;
    $[100] = t39;
    $[101] = tempProduct.id;
    $[102] = tempProduct.pricePlans;
    $[103] = t40;
  } else {
    t40 = $[103];
  }
  let t41;
  if ($[104] !== t36 || $[105] !== t40) {
    t41 = {
      key: "price plans",
      title: t36,
      element: t40
    };
    $[104] = t36;
    $[105] = t40;
    $[106] = t41;
  } else {
    t41 = $[106];
  }
  let t42;
  if ($[107] !== t) {
    t42 = t("dashboard.store.product.checkout.payment_methods");
    $[107] = t;
    $[108] = t42;
  } else {
    t42 = $[108];
  }
  const t43 = errors["digitalStore.paymentMethods"];
  let t44;
  if ($[109] !== t43) {
    t44 = <PaymentMethodsEditModal errors={{
      paymentMethods: t43
    }} />;
    $[109] = t43;
    $[110] = t44;
  } else {
    t44 = $[110];
  }
  let t45;
  if ($[111] !== t42 || $[112] !== t44) {
    t45 = {
      key: "payment methods",
      title: t42,
      element: t44
    };
    $[111] = t42;
    $[112] = t44;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  let t46;
  if ($[114] !== t30 || $[115] !== t35 || $[116] !== t41 || $[117] !== t45 || $[118] !== t9) {
    t46 = <ItemSteps steps={[t9, t30, t35, t41, t45]} />;
    $[114] = t30;
    $[115] = t35;
    $[116] = t41;
    $[117] = t45;
    $[118] = t9;
    $[119] = t46;
  } else {
    t46 = $[119];
  }
  return t46;
};
export default CheckoutTab;